import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="nosotras" className="py-32 md:py-40 px-6 md:px-12 lg:px-24 bg-rose-blush text-charcoal" data-id="element-9">
      <div className="max-w-7xl mx-auto" data-id="element-10">
        {/* Eyebrow & Divider */}
        <div className="mb-16 md:mb-24" data-id="element-11">
          <span className="text-xs font-sans uppercase tracking-[0.3em] text-charcoal/60 block mb-4" data-id="element-12">
            — 01 / NOSOTRAS
          </span>
          <div className="w-full h-[1px] bg-charcoal/10" data-id="element-13" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start" data-id="element-14">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1
        }} className="lg:col-span-4 flex flex-col" data-id="element-15">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif italic mb-8 leading-[1.1] text-charcoal" data-id="element-16">
              Un espacio
              <br data-id="element-17" />
              para ti!
            </h2>
            <div className="space-y-6 font-sans text-sm md:text-base text-charcoal/70 leading-relaxed" data-id="element-18">
              <p data-id="element-19">
                <strong className="font-medium text-charcoal" data-id="element-20">
                  Aventuras por el Mundo
                </strong>{' '}
                es un espacio pensado para mujeres que quieren volver a ellas
                mismas, conectar con otras y vivir algo que va mucho más allá de
                un destino.
              </p>
              <p data-id="element-21">
                Cada viaje está diseñado con intención: para que te sientas
                acompañada, segura, libre... y parte de algo mucho más grande.
              </p>
            </div>
          </motion.div>

          {/* Right Column - Cards */}
          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6" data-id="element-22">
            {[{
            num: '01',
            title: 'Viajes con propósito',
            desc: 'No son viajes turísticos. Son experiencias diseñadas para reconectar contigo, compartir con otras mujeres y vivir momentos que marcan.',
            video: 'https://cdn.magicpatterns.com/uploads/iowbMVx2eRfYqXoV12vHiD/video 3.mov'
          }, {
            num: '02',
            title: 'Todo organizado',
            desc: 'Nos encargamos de cada detalle para que tú solo te dediques a disfrutar, soltar y vivir la experiencia.',
            video: 'https://cdn.magicpatterns.com/uploads/dcm4qLmqSUi3ueWikaypYZ/video 1.mov'
          }, {
            num: '03',
            title: 'Acompañamiento',
            desc: 'Viajas con un grupo de mujeres y una guía que sostiene, acompaña y crea espacios de conexión durante todo el viaje.',
            video: 'https://cdn.magicpatterns.com/uploads/aZcLnbWCS7DRNGDne1vfcr/video 2.mov'
          }].map((card, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.8,
            delay: idx * 0.2
          }} className="flex flex-col group" data-id="element-23">
                <div className="relative h-[300px] md:h-[350px] rounded-2xl overflow-hidden mb-6" data-id="element-24">
                  {card.video ? <video src={card.video} autoPlay loop muted playsInline className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-1000 ease-out" data-id="element-25" /> : <img src={card.img} alt={card.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-1000 ease-out" data-id="element-26" />}
                </div>
                <div className="flex items-baseline gap-3 mb-3" data-id="element-27">
                  <span className="text-xs font-sans text-rose-primary font-medium tracking-wider" data-id="element-28">
                    {card.num}
                  </span>
                  <h3 className="text-xl font-serif italic text-charcoal leading-tight" data-id="element-29">
                    {card.title}
                  </h3>
                </div>
                <p className="font-sans text-sm text-charcoal/60 leading-relaxed" data-id="element-30">
                  {card.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}